"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Phase1 = Phase1;
require("core-js/modules/es.promise.js");
var _ontiltleftBare = require("../assets/blocks/ontiltleft-bare.svg");
var _GaugePhase = require("./GaugePhase");
var _cogTiltLeft = _interopRequireDefault(require("../assets/cogTiltLeft.gif"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const initialBlock = {
  block: "tiltleft",
  execute: async () => true
};
function Phase1(_ref) {
  let {
    nextPhase
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_GaugePhase.GaugePhase, {
    nextPhase: nextPhase,
    BlocksConnectedIcon: _ontiltleftBare.ReactComponent,
    initialBlock: initialBlock,
    blocksGif: _cogTiltLeft.default
  });
}